<template>
   <div>


    <form>
        <p class="mt-2 lead">SKU Abkürzungen vorhanden:

            <abbr title="HyperText Markup Language" @click="$bvModal.show('modal-xl')">{{skuReplacementList.length}}</abbr>
        </p>

        <b-modal hide-footer id="modal-xl" size="xl" v-bind:title="'Einträge vorhanden: ' + skuReplacementList.length">
            <b-table :items="skuReplacementList" :fields="columns" sticky-header borderless class="table table-condensed"
                     striped hover>
                <template #cell(original)="row">
                    {{row.item.original}}
                </template>
                <template #cell(replaced)="row">
                    {{row.item.replaced}}
                </template>

                <template #cell(actions)="row">
                    <b-button size="sm" @click="deleteSKURepl(row.item)" class="mr-1">
                        Delete
                    </b-button>

                </template>

            </b-table>
        </b-modal>


        <h6 class="mt-3 lead">Ankürzung hinzufügen:</h6>
        <div class="input-group ">

            <input type="text" placeholder="Langtext" class="form-control" v-model="addOriginalSKU">
            <input type="text" placeholder="Ersetzen" class="form-control" v-model="addReplacedSKU">
            <div class="input-group-append">
                <b-button class="btn btn-outline-light" type="button" @click="addSKU">Abkürzung hinzufügen
                </b-button>
            </div>
        </div>
    </form>
   </div>
</template>

<script>
    import Api from '../api'

    export default {
        data() {
            return {
                addOriginalSKU: '',
                materials: [],
                addReplacedSKU: '',
                skuReplacementList: [],
                selectedMaterial: {},
                isLoading: false,
                specFeatureAdd: '',
                bulletPointAdd: '',
                compatibleModelAdd: '',
                newMaterial: {},
                columns:[
                    {
                        key:'original',
                        label:"Original"

                    },
                    {
                        key: 'replaced',
                        label:"Ersetzt"
                    },
                    { key: 'actions', label: 'Actions' }
                ]
            }
        },
        methods: {

            deleteSKURepl(item){
                let that = this
                if(item._id){
                    Api.sku.deleteSKUReplacement(item._id)
                        .then(res => {
                            if(res.status !== 200){
                                throw new Error("Fehler beim Löschen")
                            }
                            this.makeToast('success', 'SKU Alias ' + item.original + ' wurde erfolgreich gelöscht.', 'Erfolgreich')
                            that.loadSKUReplacements()

                        })
                        .catch(e => {
                            this.makeToast('danger', 'SKU Alias ' + item.original + ' konnte nicht gelöscht werden Fehler: ' + e.message, 'Fehler')

                        })
                }
            },

            deleteMaterial(){
                let that = this;
                if(this.selectedMaterial && this.selectedMaterial._id){
                    this.isLoading = true;
                    Api.materials.deleteMaterial(this.selectedMaterial)
                        .then(result => {
                            if(result.status !== 200) throw new Error("Interner Server Fehler")
                            this.isLoading = false
                            this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' wurde erfolgreich gelöscht.', 'Erfolgreich')

                        })
                        .catch( e => {
                            this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' konnte nicht gelöscht werden. Fehler: ' + e.message, 'Fehler')

                        })

                }
            },


            hideModalDelete(){
                this.$refs['my-modal'].hide()

            },

            createNewMaterial(){
                this.isLoading = true
                var that = this
                if(this.newMaterial && this.newMaterial.material && this.newMaterial.materialName && this.newMaterial.parentSKU){
                    Api.materials.createMaterial(this.newMaterial)
                        .then(result => {
                            if (result.status === 200) {


                                this.loadMaterials()
                                this.isLoading = false
                                this.makeToast('success', 'Material ' + that.newMaterial.materialName + ' wurde erfolgreich erstellt.', 'Erfolgreich')
                                that.newMaterial = {}

                            } else {
                                this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden.', 'Fehler')
                                this.isLoading = false
                            }
                        })
                        .catch(e => {
                            this.isLoading = false
                            this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden. Fehler: ' + e.message, 'Fehler')
                        })

                }else{
                    this.isLoading = false
                    this.makeToast('danger', 'Material ' + that.newMaterial.materialName + ' konnte nicht erstellt werden.', 'Fehler')

                }
            },
            deleteCompModel(index){

                console.log("in deleteCompModel")
                console.log("Index %s", index)
                console.log(JSON.stringify(this.selectedMaterial.compatibleModels))
                this.selectedMaterial.compatibleModels.splice(index, 1);
                console.log(JSON.stringify(this.selectedMaterial.compatibleModels))
            },
            addSpecFeautre(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.specFeatureAdd.length != 0){
                    if(!this.selectedMaterial.specialFeatures) this.selectedMaterial.specialFeatures = []
                    this.selectedMaterial.specialFeatures.push(this.specFeatureAdd)
                    this.specFeatureAdd = ''
                }
            },

            addCompatibleModels(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.compatibleModelAdd.length != 0){
                    if(!this.selectedMaterial.compatibleModels) this.selectedMaterial.compatibleModels = []
                    let parsedModels = this.compatibleModelAdd.split(',').map(item => item.trim()).filter(item => item.length != 0)
                    this.selectedMaterial.compatibleModels.push(parsedModels)
                    this.compatibleModelAdd = ''
                }
            },

            addBulletPoint(){
                if(this.selectedMaterial && this.selectedMaterial._id && this.bulletPointAdd.length != 0){
                    if(!this.selectedMaterial.bulletPoints) this.selectedMaterial.bulletPoints = []
                    this.selectedMaterial.bulletPoints.push(this.bulletPointAdd)
                    this.bulletPointAdd = ''
                }
            },
            saveData() {
                this.isLoading = true;
                console.log(this.selectedMaterial)
                let that = this;
                Api.materials.updateMaterial(this.selectedMaterial)
                    .then(result => {
                        if (result.status === 200) {


                            this.loadMaterials()
                            this.isLoading = false
                            this.makeToast('success', 'Material ' + that.selectedMaterial.materialName + ' wurde erfolgreich aktualisiert.', 'Erfolgreich')
                            // this.selectedMaterial = {}
                            // this.selectedMaterialTxt = ''

                        } else {
                            this.makeToast('danger', 'Material ' + that.selectedMaterial.materialName + ' konnte nicht aktualisiert werden.', 'Fehler')
                            // this.eanAdd = ''
                            this.isLoading = false
                        }
                    })
                    .catch(e => {
                        this.makeToast('danger', 'Material ' + that.selectedMaterial.materialName + ' konnte nicht aktualisiert werden.\nFehler: ' + e.message, 'Fehler')
                        this.isLoading = false
                    })

            },
            makeToast(variant = null, body = '', title = '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            },

            materialSelectionChanged(e) {
                // this.selectedMaterialTxt = e.target.outerText;
                this.selectedMaterial = this.materials.find(item => item.materialName == e.target.outerText)
            },

            addSKU() {
                if (this.addOriginalSKU.length !== 0) {

                    Api.sku.pushSKUReplacement({original: this.addOriginalSKU, replaced: this.addReplacedSKU})
                        .then(result => {
                            if (result.status === 200) {
                                this.makeToast('success', 'SKU Abkürzung wurde erfolgreich hinzugefügt', 'Erfolgreich')
                                this.addOriginalSKU = ''
                                this.addReplacedSKU = ''
                                this.loadSKUReplacements()
                            } else {
                                this.makeToast('danger', 'SKU Abkürzung konnte nicht hinzugefügt werden', 'Fehler')
                                // this.eanAdd = ''
                            }
                        })
                        .catch(e => {
                            this.makeToast('danger', 'SKU Abkürzung konnte nicht hinzugefügt werden.\nFehler: ' + e.message, 'Fehler')

                        })
                } else {
                    this.makeToast('warning', 'Originaltext oder Abkürzung ist leer (min. 1 Zeichen erforderlich).', 'Warnung')

                }
            },


            loadSKUReplacements() {
                Api.sku.getSKUReplacements()
                    .then(data => data.data)
                    .then(data => {
                        this.skuReplacementList = data
                    })
                    .catch((e) => {
                        this.skuReplacementList = []
                        this.makeToast("danger", e.message ? e.message : "Fehler", "Fehler beim SKU Abruf")
                    })
            },

            loadMaterials() {
                let that = this

                Api.materials.getMaterials()
                    .then(response => response.data)
                    .then(data => {
                        that.materials = data
                    })
                    .catch((e) => {
                        this.skuReplacementList = []
                        this.makeToast("danger", e.message ? e.message : "Fehler", "Fehler beim SKU Abruf")
                    })
            }

        },

        name: "SkuAlias",
        beforeMount() {
            // console.log("Before mount sku alias")
            // let jwt = this.$cookies.get("authToken")
            // console.log(jwt)
            // let that = this
            // Api.auth.verify({authToken: jwt})
            //     .then(response => {
            //         if (response.status == 200) {
            //             this.$store.commit('setUser', true);
            //             Api.init(jwt);
            //             that.loadSKUReplacements()
            //
            //         }
            //     })
            //     .catch((e) => {
            //         console.log("catch")
            //         console.log(e)
            //         this.$store.commit('setUser', false)
            //         this.$router.push({path: '/'})
            //     })

            console.warn("Before mount")
            let jwt = this.$cookies.get("authToken")
            // console.log(jwt)

            var that = this
            Api.auth.verify({authToken: jwt})
                .then(response => {
                    if (response.status !== 200) throw new Error("Failed to authorize")
                        this.$store.commit('setUser', true);
                        Api.init(jwt);
                        that.loadSKUReplacements()
                })
                .catch(() => {
                    this.$store.commit('setUser', false)
                    this.$router.push({path: '/'})
                })


        }
    }
</script>

<style scoped>

</style>
